<style lang="stylus" scoped>
.personalpagewrap
  background: #f6fafc
</style>

<template>
  <div class="personalpagewrap">
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  name: 'PersonalPage',
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route.fullPath + +new Date();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/personalpage/index.vue